module.exports = __webpack_public_path__ + "static/media/arrow-link-down-expand-small_white.f367d67f.svg";